import { render, staticRenderFns } from "./SkuCategoryPropDialog.vue?vue&type=template&id=477dd8d4&scoped=true"
import script from "./SkuCategoryPropDialog.vue?vue&type=script&lang=js"
export * from "./SkuCategoryPropDialog.vue?vue&type=script&lang=js"
import style0 from "./SkuCategoryPropDialog.vue?vue&type=style&index=0&id=477dd8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477dd8d4",
  null
  
)

export default component.exports